import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { CreateVehicleMaintenanceDto } from '../../dtos/create-vehicle-maintenance.dto';
import { UpdateVehicleMaintenanceDto } from '../../dtos/update-vehicle-maintenance.dto';
import { createVehicleMaintenanceSchema } from '../schemas/create-vehicle-maintenance.schema';
import { updateVehicleMaintenanceSchema } from '../schemas/update-vehicle-maintenance.schema';

/**
 * Validates record data for creation or update.
 * @param record - The record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canCreateOrUpdate = (
	record: CreateVehicleMaintenanceDto | UpdateVehicleMaintenanceDto,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check if record is provided
	if (!record) throw new Error('record is required.');

	let validationResult: ValidationResult | undefined;

	// Determine if it's an update or create operation by checking for 'id'
	if ('id' in record && record.id) {
		// Validate against updateVehicleMaintenanceSchema if 'id' is present
		validationResult = updateVehicleMaintenanceSchema().validate(record, {
			abortEarly,
		});
	} else {
		// Validate against createVehicleMaintenanceSchema if 'id' is not present
		validationResult = createVehicleMaintenanceSchema().validate(record, {
			abortEarly,
		});
	}

	// Check for validation errors
	if (validationResult?.error) {
		return {
			isValid: false,
			errors: validationResult.error.details?.map((e) => e.message),
		};
	}

	// Return valid result if no errors
	return { isValid: true };
};
